export const getSliceSubdomain = (chainId: number) => {
  switch (chainId) {
    case 5:
      return "testnet."
    case 8453:
      return "base."
    case 84531:
      return "base-testnet."
    default:
      return ""
  }
}
